import Vue from "vue";
import VueRouter from "vue-router";

// 解决报错
const originalPush = VueRouter.prototype.push;
const originalReplace = VueRouter.prototype.replace;
// push
VueRouter.prototype.push = function push(location, onResolve, onReject) {
  if (onResolve || onReject)
    return originalPush.call(this, location, onResolve, onReject);
  return originalPush.call(this, location).catch((err) => err);
};
// replace
VueRouter.prototype.replace = function push(location, onResolve, onReject) {
  if (onResolve || onReject)
    return originalReplace.call(this, location, onResolve, onReject);
  return originalReplace.call(this, location).catch((err) => err);
};
Vue.use(VueRouter);

const router = new VueRouter({
  // mode: "hash",
  mode:"history",
  routes: [
    {
      path: "/",
      name: "index",
      redirect: "/home",
    },
    {
      path: "/login",
      name: "login",
      component: () => import("../views/login/index.vue"),
      meta: {
        title: "登录",
        keywords: "",
        description: "",
        requireAuth: false,
      },
    },
    {
      path: "/publish",
      name: "publish",
      component: () => import("../views/Publish/index.vue"),
      meta: {
        title: "发布",
        keywords: "",
        description: "",
        requireAuth: false,
      },
    },
    {
      path: "/home",
      name: "home",
      component: () => import("../views/home/index.vue"),
      meta: {
        title: "首页",
        keywords: "",
        description: "",
        requireAuth: false,
      },
    },
    {
      path: "/articleDetail",
      name: "articleDetail",
      component: () => import("../views/articleDetail/index.vue"),
      meta: {
        title: "详情",
        keywords: "",
        description: "",
        requireAuth: false,
      },
    },
    {
      path: "/search",
      name: "search",
      component: () => import("../views/search/index.vue"),
      meta: {
        title: "搜索",
        keywords: "",
        description: "",
        requireAuth: false,
      },
    },
    {
      path: '/footerType',
      name: 'footerType',
      component: () => import('@/views/footerType/index.vue'),
      meta: { title: '底部模块-长安康' }
    },
    {
      path: "/healthUs",
      name: "healthUs",
      component: () => import("../views/healthUs/index.vue"),
      meta: {
        title: "健康大家",
        keywords: "",
        description: "",
        requireAuth: false,
      },
    },
    {
      path: "/healthUsDetail",
      name: "healthUsDetail",
      component: () => import("../views/healthUs/detail.vue"),
      meta: {
        title: "健康大家详情页",
        keywords: "",
        description: "",
        requireAuth: false,
      },
    },
    {
      path: "/nutritionGuide",
      name: "nutritionGuide",
      component: () => import("../views/nutritionGuide/index.vue"),
      meta: {
        title: "膳食营养指南",
        keywords: "",
        description: "",
        requireAuth: false,
      },
    },
    {
      path: "/doctorTalk",
      name: "doctorTalk",
      component: () => import("../views/doctorTalk/index.vue"),
      meta: {
        title: "医患谈",
        keywords: "",
        description: "",
        requireAuth: false,
      },
    },
    {
      path: "/medicalGuide",
      name: "medicalGuide",
      component: () => import("../views/medicalGuide/index.vue"),
      meta: {
        title: "就医指南",
        keywords: "",
        description: "",
        requireAuth: false,
      },
    },
    {
      path: "/healthHazards",
      name: "healthHazards",
      component: () => import("../views/healthHazards/index.vue"),
      meta: {
        title: "健康危害",
        keywords: "",
        description: "",
        requireAuth: false,
      },
    },
    {
      path: "/preventingDiseases",
      name: "preventingDiseases",
      component: () => import("../views/preventingDiseases/index.vue"),
      meta: {
        title: "预防疾病",
        keywords: "",
        description: "",
        requireAuth: false,
      },
    },
    {
      path: "/decode",
      name: "decode",
      component: () => import("../views/decode/index.vue"),
      meta: {
        title: "体检与解读",
        keywords: "",
        description: "",
        requireAuth: false,
      },
    },
    {
      path: "/selfExamination",
      name: "selfExamination",
      component: () => import("../views/selfExamination/index.vue"),
      meta: {
        title: "健康自查",
        keywords: "",
        description: "",
        requireAuth: false,
      },
    },
    {
      path: "/aidKnowledge",
      name: "aidKnowledge",
      component: () => import("../views/aidKnowledge/index.vue"),
      meta: {
        title: "急救知识",
        keywords: "",
        description: "",
        requireAuth: false,
      },
    },
    {
      path: "/healthChina",
      name: "healthChina",
      component: () => import("../views/healthChina/index.vue"),
      meta: {
        title: "健康中国",
        keywords: "",
        description: "",
        requireAuth: false,
      },
    },
    {
      path: "/zhiweibing",
      name: "zhiweibing",
      component: () => import("../views/zhiweibing/index.vue"),
      meta: {
        title: "治未病",
        keywords: "",
        description: "",
        requireAuth: false,
      },
    },
    {
      path: "/specialist",
      name: "specialist",
      component: () => import("../views/specialist/index.vue"),
      meta: {
        title: "专科",
        keywords: "",
        description: "",
        requireAuth: false,
      },
    },
    {
      path: "/specialistDetail",
      name: "specialistDetail",
      component: () => import("../views/specialist/index_info.vue"),
      meta: {
        title: "专科",
        keywords: "",
        description: "",
        requireAuth: false,
      },
    },
    
    {
      path: "/expert",
      name: "expert",
      component: () => import("../views/expert/index.vue"),
      meta: {
        title: "专家",
        keywords: "",
        description: "",
        requireAuth: false,
      },
    },
    {
      path: "/expertDetail",
      name: "expertDetail",
      component: () => import("../views/expert/detail.vue"),
      meta: {
        title: "专家详情",
        keywords: "",
        description: "",
        requireAuth: false,
      },
    },
    {
      path: "/publicWelfare",
      name: "publicWelfare",
      component: () => import("../views/publicWelfare/index.vue"),
      meta: {
        title: "公益",
        keywords: "",
        description: "",
        requireAuth: false,
      },
    },
    {
      path: "/warning",
      name: "warning",
      component: () => import("../views/warning/index.vue"),
      meta: {
        title: "警示",
        keywords: "",
        description: "",
        requireAuth: false,
      },
    },
    {
      path: "/healthCare",
      name: "healthCare",
      component: () => import("../views/healthCare/index.vue"),
      meta: {
        title: "养生保健",
        keywords: "",
        description: "",
        requireAuth: false,
      },
    },
    {
      path: "/dietaryNutrition",
      name: "dietaryNutrition",
      component: () => import("../views/dietaryNutrition/index.vue"),
      meta: {
        title: "膳食营养",
        keywords: "",
        description: "",
        requireAuth: false,
      },
    },
    {
      path: "/sport",
      name: "sport",
      component: () => import("../views/sport/index.vue"),
      meta: {
        title: "运动健身",
        keywords: "",
        description: "",
        requireAuth: false,
      },
    },
    {
      path: "/sciencePopularization",
      name: "sciencePopularization",
      component: () => import("../views/sciencePopularization/index.vue"),
      meta: {
        title: "健康科普",
        keywords: "",
        description: "",
        requireAuth: false,
      },
    },
    {
      path: "/education",
      name: "education",
      component: () => import("../views/education/index.vue"),
      meta: {
        title: "健康培训",
        keywords: "",
        description: "",
        requireAuth: false,
      },
    },
    {
      path: "/healthTechniques",
      name: "healthTechniques",
      component: () => import("../views/healthTechniques/index.vue"),
      meta: {
        title: "健康技法",
        keywords: "",
        description: "",
        requireAuth: false,
      },
    },
    {
      path: "/healthIntegration",
      name: "healthIntegration",
      component: () => import("../views/healthIntegration/index.vue"),
      meta: {
        title: "健康整合",
        keywords: "",
        description: "",
        requireAuth: false,
      },
    },
    {
      path: "/mentalHealth",
      name: "mentalHealth",
      component: () => import("../views/mentalHealth/index.vue"),
      meta: {
        title: "心理健康",
        keywords: "",
        description: "",
        requireAuth: false,
      },
    },
    {
      path: "/training",
      name: "training",
      component: () => import("../views/training/index.vue"),
      meta: {
        title: "康复训练",
        keywords: "",
        description: "",
        requireAuth: false,
      },
    },
    {
      path: "/healthManagement",
      name: "healthManagement",
      component: () => import("../views/healthManagement/index.vue"),
      meta: {
        title: "健康管理",
        keywords: "",
        description: "",
        requireAuth: false,
      },
    },
    {
      path: "/offlineHealthcare",
      name: "offlineHealthcare",
      component: () => import("../views/offlineHealthcare/index.vue"),
      meta: {
        title: "线下保健",
        keywords: "",
        description: "",
        requireAuth: false,
      },
    },
    {
      path: '/merchantMap',
      component: () => import('@/views/merchantMap'),
      name: 'MerchantMap',
      meta: { title: '商户地图' }
    },
    {
      path: "/merchantDetail",
      name: "merchantDetail",
      component: () => import("../views/merchant/detail.vue"),
      meta: {
        title: "商户详情",
        keywords: "",
        description: "",
        requireAuth: false,
      },
    },
    {
      path: "/merchant/service/:id",
      name: "serviceDetail",
      component: () => import("../views/merchant/serviceDetail.vue"),
      meta: {
        title: "服务项目详情",
        keywords: "",
        description: "",
        requireAuth: false,
      },
    },
    {
      path: "/academicActivities",
      name: "academicActivities",
      component: () => import("../views/academicActivities/index.vue"),
      meta: {
        title: "学术活动",
        keywords: "",
        description: "",
        requireAuth: false,
      },
    },
    {
      path: "/personal",
      name: "personal",
      component: () => import("../views/personal/index.vue"),
      meta: {
        title: "个人中心",
        keywords: "",
        description: "",
        requireAuth: false,
      },
    },
    {
      path: "/certification",
      name: "certification",
      component: () => import("../views/certification/index.vue"),
      meta: {
        title: "认证页面",
        keywords: "",
        description: "",
        requireAuth: false,
      },
    },
    {
      path: "/activityDetail",
      name: "activityDetail",
      component: () => import("../views/academicActivities/detail.vue"),
      meta: {
        title: "活动详情",
        keywords: "",
        description: "",
        requireAuth: false,
      },
    },
    {
      path: "/article/purchase",
      name: "ActivitySignup",
      component: () => import("@/views/articlesPurchase/index.vue"),
    },
    {
      path: "/academicActivities/signup",
      name: "ActivitySignup",
      component: () => import("@/views/academicActivities/signup.vue"),
    },
    {
      path: "/academicActivities/payment",
      name: "ActivityPayment",
      component: () => import("@/views/academicActivities/payment.vue"),
    },
    {
      path: "/articleDetail",
      name: "articleDetail",
      component: () => import("../views/articleDetail/index.vue"),
      meta: {
        title: "详情",
        keywords: "",
        description: "",
        requireAuth: false,
      },
    },
    {
      path: "/difficult-critical-chinese-medicine",
      name: "DifficultCriticalChineseMedicine",
      component: () =>
        import("../views/difficultCriticalChineseMedicine/index.vue"),
    },
    // ... existing code ...
{
  path: '/feedback',
  name: 'Feedback',
  component: () => import('@/views/feedback/index.vue')
},
{
  path: '/healthUs/bookDetail',
  name: 'bookDetail',
  component: () => import('@/views/healthUs/bookDetail.vue')
},
// ... existing code ...
    {
      path: "/diseaseCategories",
      name: "diseaseCategories",
      component: () => import("../views/diseaseCategories/index.vue"),
      meta: { title: "疾病导航", standaloneLayout: true },
    },
    {
      path: "/disease",
      name: "disease",
      component: () => import("../views/disease/index.vue"),
    },
  ],
});

//路由拦截
router.beforeEach((to, from, next) => {
  let token = localStorage.getItem("token");
  let userId = localStorage.getItem("userId");
  let user_is_login = token && userId;

  // debugger
  if (!user_is_login && to.meta.requireAuth) {
    console.log("请先登录");
    // debugger

    // this.$message.error("请先登录");
    next("/login");
  } else {
    next();
  }
});

router.afterEach((to, from) => {
  // //console.log("切换导航, 重新配置微信分享");
  // wxShare.getSign();
});

export default router;
